import moment from "moment";
export const coureurCategories = {
    //Get FFA athlete category (string) from birth year (int)
    get_ffa(date_naissance, module) {

        if (!date_naissance) return "-";
        let date_module = moment(module.evenement.date_debut);
        let season = date_module.year();
        if (date_module.month() > 7) season++;
        let naissance = moment(date_naissance);
        let year = naissance.year();
        if (!year) return "-";
        let age = season - year;
        if (age <= 6) {
            return "BB"
        }
        else if (age <= 9) {
            return "EA"
        }
        else if (age <= 11) {
            return "PO"
        }
        else if (age <= 13) {
            return "BE"
        }
        else if (age <= 15) {
            return "MI"
        }
        else if (age <= 17) {
            return "CA"
        }
        else if (age <= 19) {
            return "JU"
        }
        else if (age <= 22) {
            return "ES"
        }
        else if (age <= 34) {
            return "SE"
        }
        else if (age <= 39) {
            return "M0"
        }
        else if (age <= 44) {
            return "M1"
        }
        else if (age <= 49) {
            return "M2"
        }
        else if (age <= 54) {
            return "M3"
        }
        else if (age <= 59) {
            return "M4"
        }
        else if (age <= 64) {
            return "M5"
        }
        else if (age <= 69) {
            return "M6"
        }
        else if (age <= 74) {
            return "M7"
        }
        else if (age <= 79) {
            return "M8"
        }
        else if (age <= 84) {
            return "M9"
        }
        else if (age >= 85) {
            return "M10"
        }


    },

    get_categorie_select() {
        return [
            { text: "Toutes les catégories", value: "" },
            { text: "BB", value: "BB" },
            { text: "EA", value: "EA" },
            { text: "PO", value: "PO" },
            { text: "BE", value: "BE" },
            { text: "MI", value: "MI" },
            { text: "CA", value: "CA" },
            { text: "JU", value: "JU" },
            { text: "ES", value: "ES" },
            { text: "SE", value: "SE" },
            { text: "M0", value: "M0" },
            { text: "M1", value: "M1" },
            { text: "M2", value: "M2" },
            { text: "M3", value: "M3" },
            { text: "M4", value: "M4" },
            { text: "M5", value: "M5" },
            { text: "M6", value: "M6" },
            { text: "M7", value: "M7" },
            { text: "M8", value: "M8" },
            { text: "M9", value: "M9" },
            { text: "M10", value: "M10" },

        ]
    },

    get_ffr(date_naissance, module) {
        if (!date_naissance) return "-";
        let date_module = moment(module.evenement.date_debut);
        let season = date_module.year();
        if (date_module.month() > 7) season++;
        let naissance = moment(date_naissance);
        let year = naissance.year();
        if (!year) return "-";
        let age = season - year;
        if (age <= 11) {
            return "-";
        }
        else if (age <= 15) {
            return "Minimes/Cadets";
        }
        else if (age <= 17) {
            return "Juniors";
        }
        else if (age <= 39) {
            return "Seniors";
        }
        else if (age <= 49) {
            return "Masters 1";
        }
        else if (age <= 59) {
            return "Masters 2";
        }
        else if (age <= 69) {
            return "Masters 3";
        }
        else if (age >= 70) {
            return "Masters 4";
        }

    }






}